import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=6ee0447e&"
var script = {}
import style0 from "./Body.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports